import { GoogleTagManager as googleTagManager } from './libraries/GoogleTagManager';

$(document).ready(function () {
    // set first thumbnail image as active on page load
    // $('.item-thumbnail-wrap').find('.thumb-wrap:visible:first img').addClass('active');
    var $itemThumbnails = $('.item-thumbnails');
    if ($('.item-thumbnails .image-thumbs').length) {
        var sly = new Sly($itemThumbnails.find('.image-thumbs'), {
            itemSelector: '.thumb-wrap:not(:hidden)',
            horizontal: true,
            itemNav: 'basic',
            activateOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: 0,
            speed: 300,
            elasticBounds: 1,
            easing: 'easeOutExpo',
            prevPage: $itemThumbnails.find('.left'),
            nextPage: $itemThumbnails.find('.right')
        }).init();
    }

    $(document).on('click', '.color_switcher', function (e) {
        e.preventDefault();

        $('.selected-color span').data('color-description', $(this).data('description'));

        setCurrentColor();

        // Scroll to order matrix item
        // if ($('.side').hasClass('sticky-product-img')) {
        scrollToMatrixItem($(this).data('color'));
        // }

        // if clicked color is allready active we dont do anything
        if ($(this).hasClass('active-color')) {
            return;
        }

        // find current active color and set it inactive
        $('.item-colors').find('.active-color').removeClass('active-color');

        // set all color thumbs hidden
        $('.thumb-wrap[data-color]').hide();

        // set clicked color active
        $(this).addClass('active-color');

        // show thumbnails for clicked color
        $('.thumb-wrap[data-color=\'' + $(this).data('color') + '\']').show();

        // set first visible thumbnail for selected color as main image
        // first try only style images (so not the model images that come first) and then, if not successful, all (BBFW-2717)
        var $itemThumbnails = $('.item-thumbnails');
        var firstImage = $itemThumbnails.find('.thumb-wrap-style:visible:first');
        if (typeof firstImage === "undefined") {
            firstImage = $itemThumbnails.find('.thumb-wrap:visible:first');
        }

        if (typeof sly !== 'undefined') {
            sly.reload();
            sly.activate(firstImage);
            swapMainImage(firstImage[0].dataset.src, zoom_width, crop_string);

            document.querySelector('button.left').classList.add('disabled');
            document.querySelector('button.left i').setAttribute('aria-hidden', 'true');
        }
    });


    // swap main image on thumbnail click
    if (typeof sly !== 'undefined') {
        sly.on('active', function (eventName, activeIndex) {
            var activeNode = sly.items[activeIndex].el;
            swapMainImage(activeNode.dataset.src, zoom_width, crop_string);

            // Scroll to order matrix item
            if ($('.product-left').hasClass('sticky-product-img')) {
                scrollToMatrixItem($(this).parent().data('color'));
            }
        });
    }


    var $carouselContainers = $('.carousel-container');
    $carouselContainers.each(function (a) {
        var $this = $(this);
        $this.find('.carousel').sly({
            itemNav: 'basic',
            horizontal: true,
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: 0,
            speed: 300,
            elasticBounds: 1,
            easing: 'easeOutExpo',
            prevPage: $this.find('.prev'),
            nextPage: $this.find('.next')
        });
    });

    $('.semantic_image_link').click(function () {
        var image_title = $(this).attr('data-image-title');
        var image = $(this).attr('data-image');

        $('.stock-modal .modal-title').html(image_title);
        $('.stock-modal .modal-body').html('<div class="image_modal_div" style="text-align:center"><img src="' + image + '" /></div>');
    });

    setCurrentColor();

    if ($('.inputs-grid').length) {
        $('.inputs-grid').each(function() {
            if ($(this).find('.cell-top-stock').length > 0) {
                let height = $(this).find('.cell-top-stock').first().height() * 2 + 3;

                $(this).find('> .cell').each(function () {
                    if ($(this).find('.cell-top-stock').length == 0) {
                        $(this).find('.cell-top').height(height + 'px');
                    }
                });
            }
        });
    }

    if (document.querySelector('.simple-product') && useGtmEcommerceEvents) {
        document.dispatchEvent(new CustomEvent('GTMViewItem'));
    }
});

let setCurrentColor = () => {
    $('.selected-color span').each(function () {
        $(this).html($(this).data('color-description'));
    });
}

function swapMainImage(src, width, crop_string) {
    var width_param = '?width=' + width,
        anim = ''; // Parameter for animated gif

    var targetSrc = src ? src.toLowerCase() : null;
    // Check if it's a gif
    if (targetSrc && targetSrc.indexOf('.gif') >= 0) {
        anim = '&anim=true';
    }

    if (targetSrc && targetSrc.indexOf('width=') >= 0) {
        width_param = '&width=' + width;
    }

    change_image_in_container($('.main-detail-image'), src + width_param + crop_string + anim);
    // var container = mainImg.parent();
    // var img = mainImg.clone();
    // var fadeOutTransition = mainImg.animate({opacity: 0}, 150).promise();
    // img.on('load', function () {
    //     fadeOutTransition.then(function () {
    //         mainImg.remove();
    //         img.animate({opacity: 1}, 150);
    //     })
    // });
    // img.attr('src', src + width_param + crop_string + anim);
    // img.css('opacity', 0);
    // container.append(img);
}

// Active sly scroller on an element
function activeSly(element, currentActiveElement) {
    if (!element.sly.initialized) {
        element.sly({
            itemNav: 'basic',
            activateOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            startAt: currentActiveElement,
            speed: 300,
            elasticBounds: 1,
            activeItem: currentActiveElement,
            easing: 'easeOutExpo',
            prevPage: element.parent().find('.up'),
            nextPage: element.parent().find('.down')
        });
    }
}

function zoomImageIn() {
    disableScroll();

    $('#zoom_popover').remove();
    $('body').append($('#zoom_popover_template').clone().attr('id', 'zoom_popover'));

    var zp = $('#zoom_popover');
    var bar = $('.bar', zp);
    var img = $('.zoom_image img', zp);

    // Close click binding
    $('.close_popover', zp).click(function () {
        img.data().smoothZoom.destroy();
        enableScroll();
        zp.remove();
    });

    // Main image
    var main_img_url = stripQueryString($('.main-detail-image').attr('src'));
    img.attr('src', main_img_url);

    // Render the thumbnails
    var i = 0;
    var currentActiveElement = 0;
    $('.thumb-wrap img').each(function () {
        var thumb = $('<img>');

        if (stripQueryString($(this).attr('src')) == main_img_url) {
            currentActiveElement = i;
        }

        thumb.attr('src', $(this).attr('src'));
        thumb.attr('class', 'img-fluid');
        thumb.attr('data-color', $(this).closest('li').attr('data-color'));

        $('.image-thumbs ul', zp).append($('<li>').append(thumb));
        i += 1;
    });

    // Bind the thumbnail toggle click
    $('.image-thumbs img', zp).click(function () {
        var imgUrl = stripQueryString($(this).attr('src'));

        // Toggle the main image
        img.attr('src', imgUrl);

        img.smoothZoom('Reset');
    });

    img.smoothZoom({
        width: '100%',
        height: '100%',
        zoom_BUTTONS_SHOW: 'NO',
        pan_BUTTONS_SHOW: 'NO',
        pan_LIMIT_BOUNDARY: 'NO',
        responsive: true,
        zoom_MIN: 0,
        zoom_MAX: zoom_level_max * 100,
        on_ZOOM_PAN_UPDATE: function () {
            var data = img.data();
            var szData = data.smoothZoom;
            checkZoomButtons(szData.rA, szData.zoom_max, szData.rF);
            checkZoomCursor(szData.rA, szData.zoom_max, szData.rF);
        }
    });

    img.bind("dblclick.sz", function (e) {
        e.preventDefault();
        var szData = img.data().smoothZoom;
        if (szData.rA == szData.zoom_max) {
            e.stopPropagation();
            img.smoothZoom('Reset');
        }
    });

    img.bind("click", function (e) {
        if (!img.data().smoothZoom.samePointRelease) {
            return false;
        }
        var evt = new MouseEvent("dblclick", {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: e.pageX,
            clientY: e.pageY
        });
        e.target.dispatchEvent(evt);
    });

    $('.zoom_in', bar).click(function () {
        img.smoothZoom('zoomIn')
    });

    $('.zoom_out', bar).click(function () {
        img.smoothZoom('zoomOut')
    });

    // Popover zoom thumbnail scroll
    activeSly(zp.find('.image-thumbs'), currentActiveElement);
}

function disableScroll() {
    $('html, body').css({
        'overflow': 'hidden'
    });
    var current = $(window).scrollTop();
    $(window).scroll(function () {
        $(window).scrollTop(current);
    });
}

function enableScroll() {
    $('html, body').css({
        'overflow': 'visible'
    });
    $(window).off('scroll');
}

function stripQueryString(url) {
    if (url === undefined) {
        return;
    }
    return url.split('?')[0];
}

function checkZoomButtons(zoomRatio, maxZoom, minZoom) {
    var zp = $('#zoom_popover'),
        zoomInButton = $('.zoom_in', zp),
        zoomOutButton = $('.zoom_out', zp);

    zoomInButton.removeClass('disabled');
    zoomOutButton.removeClass('disabled');

    if (zoomRatio == maxZoom) {
        zoomInButton.addClass('disabled');
    }

    if (zoomRatio == minZoom) {
        zoomOutButton.addClass('disabled');
    }
}

function checkZoomCursor(zoomRatio, maxZoom) {
    var img = $('#zoom_popover img');
    var maxZoomClass = 'max_zoom_level';

    if (zoomRatio == maxZoom) {
        img.addClass(maxZoomClass);
        return;
    }

    img.removeClass(maxZoomClass);
}

function scrollToMatrixItem(color_no) {
    var scroll_to_element = $('.ordermatrix .item-row[data-color-id="' + String(color_no).toLowerCase() + '"]');
    var offset            = $('body > .sticky').length ? $('body > .sticky').outerHeight() : 0;

    if (color_no && scroll_to_element.length) {
        $('html, body').animate({
            scrollTop: scroll_to_element.offset().top - offset
        }, 500);
    }
}

$('.hmz_extra_info').click(function () {
    let model = $(this).attr('data-model'),
        color = $(this).attr('data-color');

    $('.modal-title').html('Stocklocations');
    let html = $('#' + model + '_' + color + '_hmz').html();
    $('.modal-body').html(html);
});

$(document).on('order-matrix-loaded', function() {
    var initialcolor = $('.item-colors .active-color').data('color');
    scrollToMatrixItem(initialcolor);

    if (useGtmEcommerceEvents) {
        document.dispatchEvent(new CustomEvent('GTMViewItem'));
    }
});

function googleViewItemEvent() {
    let ecommerce = {},
        items = [],
        prices = [],
        priceFormat = /[0-9,.]+/g; // For showing prices without currency symbol

    ecommerce.currency = userCurrency;

    if (document.querySelector('.simple-product')) {
        let item = {},
            price = document.querySelector('.price-block strong') ? document.querySelector('.price-block strong').innerHTML.trim().match(priceFormat) : '';

        ecommerce.value = price

        item.item_id      = document.querySelector('.product') ? document.querySelector('.product').dataset.modelno : '';
        item.item_name    = document.querySelector('.product-header-block h1').innerHTML.trim();
        item.category     = document.querySelector('.product') ? document.querySelector('.product').dataset.category : '';
        item.price        = price;

        items.push(item);
    } else {
        let productElements = document.querySelectorAll('.item-row'),
            pricesElements = document.querySelectorAll('.item-row .item-colors strong');

        if (pricesElements) {
            pricesElements.forEach(function (pricesElement) {
                prices.push(pricesElement.innerText.match(priceFormat));
            });
        }

        ecommerce.value = prices;

        productElements.forEach(function (element) {
            let item = {};

            item.item_id      = document.querySelector('.product') ? document.querySelector('.product').dataset.modelno : '';
            item.item_name    = document.querySelector('.product-header-block h1').innerHTML.trim();
            item.category     = document.querySelector('.product') ? document.querySelector('.product').dataset.category : '';
            item.item_variant = element.querySelector('.color') ? element.querySelector('.color').dataset.color : '';
            item.price        = element.querySelector('strong') ? element.querySelector('strong').innerHTML.trim().match(priceFormat) : '';

            items.push(item);
        })
    }

    ecommerce.items = items;

    googleTagManager.pushToGoogle('view_item', ecommerce);
}
